import React, { memo, useEffect, useRef, useState } from "react";
import { Select } from "antd";

// Example options, you can replace or pass as props
const options = [];
for (let i = 10; i < 36; i++) {
  const value = i.toString(36) + i;
  options.push({
    label: `Long Label: ${value}`,
    value,
  });
}

export default memo(({ value = [], onValueChange, stopEditing, selectOptions = options }) => {
  const [selected, setSelected] = useState(value);
  const refContainer = useRef(null);

  useEffect(() => {
    refContainer.current?.focus();
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter" || event.key === "Escape") {
        stopEditing && stopEditing();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [stopEditing]);

  const handleChange = (vals) => {
    setSelected(vals);
    if (onValueChange) {
      onValueChange(vals);
    }
  };

  const safeOptions = Array.isArray(selectOptions)
  ? selectOptions
  : [];

  return (
    <div ref={refContainer} tabIndex={1} style={{ width: "100%" }}>
      <Select
        mode="multiple"
        style={{ width: "100%" }}
        options={safeOptions}
        placeholder="Select Item..."
        maxTagCount="responsive"
        value={selected}
        onChange={handleChange}
        autoFocus
      />
    </div>
  );
});